import React, { FC } from "react";
import { ThemeProvider } from "styled-components";
import { useParams } from "react-router-dom";

import Colors from "constants/colors";
import { AssessmentType } from "types";

import { StyledMain } from "./styles";

const themes = {
  interest: {
    colors: {
      ...Colors,
      defaultColor: Colors.scooter,
      secondaryColor: Colors.hummingBird,
    },
  },
  abstract: {
    colors: {
      ...Colors,
      defaultColor: Colors.pictonBlue,
      secondaryColor: Colors.solitude,
    },
  },
  numerical: {
    colors: {
      ...Colors,
      defaultColor: Colors.mulberry,
      secondaryColor: Colors.amour,
    },
  },
  verbal1: {
    colors: {
      ...Colors,
      defaultColor: Colors.fuelYellow,
      secondaryColor: Colors.astra,
    },
  },
  verbal2: {
    colors: {
      ...Colors,
      defaultColor: Colors.fuelYellow,
      secondaryColor: Colors.astra,
    },
  },
  verbal3: {
    colors: {
      ...Colors,
      defaultColor: Colors.fuelYellow,
      secondaryColor: Colors.astra,
    },
  },
};

const TestIntro: FC = ({ children }) => {
  const { type } = useParams<{ type: AssessmentType }>();

  return (
    <ThemeProvider theme={themes[type]}>
      <StyledMain>{children}</StyledMain>
    </ThemeProvider>
  );
};

export default TestIntro;
